import { render, staticRenderFns } from "./warn-transactions.vue?vue&type=template&id=5b1b9dd0&scoped=true"
import script from "./warn-transactions.vue?vue&type=script&lang=js"
export * from "./warn-transactions.vue?vue&type=script&lang=js"
import style0 from "./warn-transactions.vue?vue&type=style&index=0&id=5b1b9dd0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b9dd0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/warn-transactions.vue
// module id = 2KtO
// module chunks = 0